import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRelation11 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={142}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#C2C8D3"
      fillRule="evenodd"
      d="M139.5 9.516a1 1 0 0 0-1-1H3a1 1 0 0 0 0 2h135.5a1 1 0 0 0 1-1"
      clipRule="evenodd"
    />
    <path
      fill="#C2C8D3"
      d="M10 3.121a1.121 1.121 0 1 1 2.243 0v12.801a1.121 1.121 0 0 1-2.243 0z"
    />
    <path
      fill="#C2C8D3"
      fillRule="evenodd"
      d="M11.121 2C10.502 2 10 2.502 10 3.121v12.801a1.121 1.121 0 0 0 2.243 0v-12.8c0-.62-.502-1.122-1.122-1.122"
      clipRule="evenodd"
    />
    <path
      fill="#C2C8D3"
      d="M16.016 3.121a1.121 1.121 0 1 1 2.243 0v12.801a1.121 1.121 0 0 1-2.243 0z"
    />
    <path
      fill="#C2C8D3"
      fillRule="evenodd"
      d="M17.137 2c-.62 0-1.121.502-1.121 1.121v12.801a1.121 1.121 0 0 0 2.243 0v-12.8c0-.62-.503-1.122-1.122-1.122"
      clipRule="evenodd"
    />
    <path
      fill="#C2C8D3"
      d="M123.25 3.123a1.121 1.121 0 1 1 2.243 0v12.801a1.121 1.121 0 0 1-2.243 0z"
    />
    <path
      fill="#C2C8D3"
      fillRule="evenodd"
      d="M124.371 2.002c-.619 0-1.121.502-1.121 1.121v12.801a1.121 1.121 0 1 0 2.243 0v-12.8c0-.62-.502-1.122-1.122-1.122"
      clipRule="evenodd"
    />
    <path
      fill="#C2C8D3"
      d="M129.266 3.123a1.121 1.121 0 1 1 2.243 0v12.801a1.121 1.121 0 0 1-2.243 0z"
    />
    <path
      fill="#C2C8D3"
      fillRule="evenodd"
      d="M130.387 2.002c-.619 0-1.121.502-1.121 1.121v12.801a1.121 1.121 0 1 0 2.243 0v-12.8c0-.62-.502-1.122-1.122-1.122"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgRelation11;
